import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

import "../App.css"; // Importera CSS-filen
import {
  FaHome,
  FaPen,
  FaPlusCircle,
  FaChartLine,
  FaDownload,
  FaEdit,
} from "react-icons/fa";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

const Navbar = () => {
  const location = useLocation();
const path = location.pathname;

const hideNavbar =
  path === "/" ||
  path === "/privacy" ||
  path.startsWith("/feedback/");

  const tenantId = getTenantIdFromHost();
  const isTenant = tenantId !== "localhost" && tenantId !== "root";

  useEffect(() => {
    if (isTenant) {
      let title = tenantId.charAt(0).toUpperCase() + tenantId.slice(1);
      document.title = `${title} – Kundupplevelse, Feedback`;
    } else {
      document.title = "Kundupplevelse, Feedback";
    }
  }, [tenantId]);

  const setFavicon = (tenantId) => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) return;

    link.href = `/logos/${tenantId}-favicon.ico`;
  };

  useEffect(() => {
    if (tenantId) setFavicon(tenantId);
  }, [tenantId]);

  return (
    <>
      {!hideNavbar ? (
        <nav>
          <ul className="navbar">
            {" "}
            {/* Här ska listan vara horisontell */}
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "active-link" : undefined
                }
              >
                <FaHome />
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/builder"
                className={({ isActive }) =>
                  isActive ? "active-link" : undefined
                }
              >
                <FaPlusCircle /> {/* Skapa en undersökning-ikon */}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/survey"
                className={({ isActive }) =>
                  isActive ? "active-link" : undefined
                }
              >
                <FaEdit />
                {/* Undersökningar-ikon<FaPen /> */}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/visualize"
                className={({ isActive }) =>
                  isActive ? "active-link" : undefined
                }
              >
                <FaChartLine /> {/* Se Data-ikon */}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/export"
                className={({ isActive }) =>
                  isActive ? "active-link" : undefined
                }
              >
                <FaDownload /> {/* Exportera Data-ikon */}
              </NavLink>
            </li>
          </ul>
        </nav>
      ) : null}
    </>
  );
};

export default Navbar;
